import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i678570578__a)" }, [
      _createElementVNode("path", {
        fill: "#31344A",
        "fill-rule": "evenodd",
        d: "M21.77.23c.22.22.29.548.178.838L14.09 21.496a.786.786 0 0 1-1.48-.033l-3.018-9.056L.537 9.388A.786.786 0 0 1 .504 7.91L20.932.052a.786.786 0 0 1 .838.178ZM3.112 8.59l7.35 2.45a.786.786 0 0 1 .498.497l2.45 7.351 6.436-16.734L3.112 8.59Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i678570578__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h22v22H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }